import { useTranslation } from 'react-i18next'

import { DOC_FLOW_RESULT_EPOST_STATUS_BY_CODE } from '../../../../constants/docFlow'
import Button from '../../../Button'
import { EpostStatusTimelineModal } from '../../../Epost'
import { TableStatusCell } from '../../../Table'
import { useDocFlowContext } from '../../DocFlow.hooks'
import {
  DocFlowResultTableCellName,
  getDocFlowResultEpostStatuses,
} from '../../DocFlowResult'

import * as styles from './EpostStatusCell.module.css'

import InfoIcon from '../../../../icons/info.svg'
import ResendIcon from '../../../../icons/restore.svg'

function EpostStatusCell({
  canResendEpost,
  disabledResendPost,
  item,
  value,
  onEpostResend,
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleCloseModal, setModal } = useDocFlowContext()

  function handelClickViewStatus() {
    setModal(
      <EpostStatusTimelineModal
        timeline={item[DocFlowResultTableCellName.EpostStatusTimeline]}
        user={item[DocFlowResultTableCellName.Recipient]}
        onCloseModal={handleCloseModal}
      />
    )
  }

  return (
    <TableStatusCell
      {...restProps}
      className={styles.epostStatusCell}
      statuses={getDocFlowResultEpostStatuses({
        error: item[DocFlowResultTableCellName.EpostError],
        t,
      })}
      value={DOC_FLOW_RESULT_EPOST_STATUS_BY_CODE[value]}
    >
      {canResendEpost ? (
        <Button.Icon
          Icon={ResendIcon}
          disabled={disabledResendPost}
          tooltip={t(
            disabledResendPost
              ? 'DocFlow.ResendEpostButtonDisabledTooltipKey'
              : 'DocFlow.ResendEpostButtonTooltipKey'
          )}
          onClick={onEpostResend}
        />
      ) : null}
      <Button.Icon
        Icon={InfoIcon}
        tooltip={t('DocFlow.ViewEpostStatusButtonTooltipKey')}
        onClick={handelClickViewStatus}
      />
    </TableStatusCell>
  )
}

export default EpostStatusCell
